import { Option } from '@interfaces/common/option';

/**
 * Prazo da captação do deal (card 3683): 1 a 5 anos, o mesmo intervalo que o backend valida
 * (`PartnerDealValidator`). Só rótulo e opção de select: o flat fee de cada prazo e toda a conta de
 * comissão moram no backend (`PartnerFlatFeeCalculator`, card 3707), e a tela só mostra o que ele devolve.
 */
export const PARTNER_TERM_YEARS = [1, 2, 3, 4, 5] as const;

/** "1 ano", "2 anos"... */
export function partnerTermYearsLabel(termYears: number | null | undefined): string {
  if (termYears == null) return '—';
  return termYears === 1 ? '1 ano' : `${termYears} anos`;
}

/** Opções do select de prazo (1 a 5 anos). O `value` do `app-select` é string. */
export const PARTNER_TERM_YEARS_OPTIONS: Option[] = PARTNER_TERM_YEARS.map(termYears => ({
  label: partnerTermYearsLabel(termYears),
  value: String(termYears),
}));

/** Lê o valor do select (string ou número) como prazo válido; fora de 1..5 vira `null`. */
export function parsePartnerTermYears(value: unknown): number | null {
  const termYears = typeof value === 'string' && value !== '' ? Number(value) : value;
  if (typeof termYears !== 'number' || !Number.isInteger(termYears)) return null;
  return (PARTNER_TERM_YEARS as readonly number[]).includes(termYears) ? termYears : null;
}
